module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAZklEQVQ4T2NkoBAwUqifgTYGGBgYGDAzMxecPXs2gZALcbrAyMgogZGR0YGQIXi9QIwhBMOAkCEEDQCFAcgQBgaGoHPnzvmhhwntDaDIC4Q0g7xDm2ikSkIilAJh8kTFAj7DKDYAANFoKBFVI3E+AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/right.png
// module id = P9Ix
// module chunks = 1